import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-awesome/icons/regular/plus-square';
import 'vue-awesome/icons/paperclip';
import 'vue-awesome/icons/times';
import { FileService } from '~/services/file-service';
import { BudgetRequestsService } from '~/services';
import { User } from '~/utils';

@Component({})
export default class AddBudgetRequestsModalComponent extends Vue {
    public BudgetRequestService: BudgetRequestsService = new BudgetRequestsService();
    private FileBudgetRequestService: FileService = new FileService();
    private importFileExcel: any;
    private userPermissions = <any>[];
    private errorMessage = null;
    private value = null;
    private showGlobalIdInput: boolean = false;
    private globalId: string = '';
    private mtpYear: string = '';
    private isInvalid: boolean = false;
    private currentYear = new Date(Date.now()).getFullYear();
    private mtpList = [];
    private appliedPlant = '';
    private selectedTechnology = '';
    private selectedGroup = '';

    @Prop()
    private data: any;

    async created() {
        this.userPermissions = await User.getPerm();
        this.selectedTechnology = this.data.selectedTechnology;
        this.selectedGroup = this.data.selectedPlantGroup;
        this.$root.$on('changedTechnology', (selectedTechnology, selectedGroup) => {
            this.selectedTechnology = selectedTechnology;
            this.selectedGroup = selectedGroup;
            this.appliedPlant = '';
        });
        this.$root.$on('changedGroup', (selectedGroup) => {
            this.selectedGroup = selectedGroup;
            this.appliedPlant = '';
        });
    }

    public async upload(event) {
        this.showGlobalIdInput = false;
        this.isInvalid = false;
        this.globalId = '';
        this.mtpList = [];
        this.mtpYear = '';
        $('#addBudgetRequestsModal').modal('hide');
        let year = localStorage.selectedMtp;
        let data = new FormData();
        if (event.target.files.length !== 0) {
            let file = event.target.files[0];
            data.append('Year', year);
            data.append('file', file);
            this.data.selectedPlant.forEach(plant => {
                data.append('CurrentPlantSids[]', plant.plantSid);
            });

            this.data.uploadingSpreadSheet = true;
            try {
                this.errorMessage = await this.FileBudgetRequestService.importBudgetRequests(data);
                this.$bvToast.show('toast-error-import');
                if (this.errorMessage.requestIsValid) {
                    this.$emit('succesimport');
                }
                $('#file').val('');
                this.data.uploadingSpreadSheet = false;
            } catch (e) {
                $('#file').val('');
                this.data.uploadingSpreadSheet = false;
                this.$bvToast.show('toast-exception');
            }
        }
    }

    private addBr() {
        this.showGlobalIdInput = false;
        if (!this.isInvalid && this.globalId.length > 0) {
            $('#addBudgetRequestsModal').modal('hide');
            this.$router.push({
                path: 'budget-request',
                query: { year: this.mtpYear, globalId: this.globalId, isDuplicate: '1' }
            });
        } else {
            $('#addBudgetRequestsModal').modal('hide');
            this.$router.push('/budget-request');
        }
    }

    private hideToast() {
        this.$bvToast.hide('toast-error-import');
        this.$bvToast.hide('toast-exception');
    }

    private showModalError() {
        this.$emit('showerror', this.errorMessage.items);
        this.$bvToast.hide('toast-error-import');
        $('#errorModal').modal('show');
    }

    private async downloadTemplate() {
        const content = await this.FileBudgetRequestService.downloadBudgetRequests();
        this.forceFileDownload('MBM_Site submission_Import Template.xlsx', content.data);
    }

    private forceFileDownload(name, data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }

    private addGlobalIdInput() {
        this.showGlobalIdInput = true;
    }

    private async validateGlobalId() {
        this.isInvalid = false;
        this.globalId = this.globalId.trim().toUpperCase();
        if (this.globalId !== '') {
            try {
                let data = await this.BudgetRequestService.getBudgetRequestDetails(this.currentYear, this.globalId);
                this.mtpList = data.mtpList.reverse();
                this.mtpYear = this.mtpList[0];
            } catch (error) {
                this.isInvalid = true;
            }
        } else {
            this.isInvalid = false;
            this.mtpList = [];
            this.mtpYear = '';
        }
    }

    private close() {
        this.showGlobalIdInput = false;
        this.isInvalid = false;
        this.globalId = '';
        this.mtpList = [];
        this.mtpYear = '';
    }

    private changeSelectedPlant() {
        localStorage.setItem('selectedPlantId', this.appliedPlant);
    }
}
